module.exports = __webpack_public_path__ + "static/media/slide1.5e83ec6a.jpg";